var _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46,
    fill: "#0F172A",
    stroke: "#FACC15",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 32,
    fill: "#111827",
    stroke: "#FACC15",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 53,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 20,
    fontWeight: 800,
    fill: "#FACC15"
  }, "GMP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmp);
export default __webpack_public_path__ + "static/media/gmp.4733aa6c8990b5cb207a30eacec1dcd9.svg";
export { ForwardRef as ReactComponent };